import {getContractList} from '@/api/contract.js'
import {getList} from '@/api/worklog.js'
import {getList as baogongsum} from '@/api/baogongzhangdan.js'
import {getfafangtongji} from '@/api/paylog.js'
import {add} from '@/utils/math.js'

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
export default {
	data(){
		return {
			baoxiaoinfo:{pricesum:"0",pricesum0:"0",pricesum1:"0"},
			cailiaoinfo:{pricesum:"0",pricesum0:"0",pricesum1:"0"},
			diangonginfo:{peoplenum:"0",peoplenum0:"0",peoplenum1:"0"},
			baogonginfo:{peoplenum:"0",peoplenum0:"0",peoplenum1:"0"},
			moneydiangong:{shifa:"0",workday:"0",yingfa:"0",yuzhi:"0"},
			moneydaiban:{shifa:"0",workday:"0",yingfa:"0",yuzhi:"0"},
			moneybanzu:{jieyu:"0",workday:"0",yingfu:"0",yuzhi:"0"},
			fafang:{diangong:"0",daiban:"0",banzu:"0",sum:"0"},

		}
	},
	methods:{
		getbaoxiao(){
			getContractList({type:6,status:3,cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{pricesum,pricesum0,pricesum1}} = ret
					this.baoxiaoinfo = {
						pricesum,pricesum0,pricesum1
					}
					
				}
			})
		},
		getcailiao(){
			getContractList({type:7,status:3,cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{pricesum,pricesum0,pricesum1}} = ret
					this.cailiaoinfo = {
						pricesum,pricesum0,pricesum1
					}
				}
			})
		},
		getdiangong(){
			getContractList({type:[2,3,4],status:3,worktype:[1,2],cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{peoplenum,peoplenum0,peoplenum1}} = ret
					this.diangonginfo = {
						peoplenum,peoplenum0,peoplenum1
					}
				}
			})
		},
		getbaogong(){
			getContractList({type:[1,3,4],status:3,worktype:3,cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{peoplenum,peoplenum0,peoplenum1}} = ret
					this.baogonginfo = {
						peoplenum,peoplenum0,peoplenum1
					}
				}
			})
		},
		getmoneydiangong(){
			getList({worktype:1,cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{sum:{shifa,workday,yingfa,yuzhi}}} = ret
					this.moneydiangong = {shifa,workday,yingfa,yuzhi}
				} 
			})
		},
		getmoneydaiban(){
			getList({worktype:2,cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{sum:{shifa,workday,yingfa,yuzhi}}} = ret
					this.moneydaiban = {shifa,workday,yingfa,yuzhi}
				} 
			})
		},
		getbaogongsum(){
			baogongsum({cmpid:user.cmpid}).then(ret=>{
				if(ret.code == 0){
					let {data:{sum:{jieyu,workday,yingfu,yuzhi}}} = ret
					this.moneybanzu = {jieyu,workday,yingfu,yuzhi}
				}
			})
		},
		getfafangsum(){
			getfafangtongji({cmpid:user.cmpid}).then(res=>{
				if(res.code==0){
					let {ret} = res,types = ["","diangong","daiban","banzu"],tmp ={},nums=[]
					// 1:点工，2:带班, 3:班组
					ret.forEach(item=>{
						let {worktype,money} = item
						if(worktype == "1"||worktype=="2"||worktype=="3"){
							tmp[types[worktype]] = money
							nums.push(money)
						}
					})
					this.fafang = {...tmp,sum:add(nums)}
				}

			})
		}

	},
	mounted(){
		this.getbaoxiao()
		this.getcailiao()
		this.getdiangong()
		this.getbaogong()
		this.getmoneydiangong()
		this.getmoneydaiban()
		this.getbaogongsum()
		this.getfafangsum()
		
	}
}